<div class="animated fadeIn">
<!-- <h3>Admin Panel</h3>
                <br/> -->

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">Data Lock Settings </h4>
             
              <br/>
              <div style="border: 2px solid #dee2e6; padding: 10px; margin-top: 10px;" id="editCont" *ngFor="let item of configData; let i=index;"> 
              	<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        {{item.title}}
                                    </label></div>
                                    <div class="col-12 col-md-6">
                                        <input name="configVal{{i}}"  id="configVal{{i}}" [(ngModel)]="configVal[i]" class="form-control-sm form-control" required="" (keypress)="numberOnly($event)"  />{{item.keyUnit}}
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="updateConfig(item.keyIndex,i)" >Update</button>
                                             
                                        </div>

                                    </div>
                                </div>
                               
                </div>
                
            </div>
        </div>
       


</div>
</div><!-- .animated -->

